import moment from "moment";

/**
 * A till session is "valid" while it was started on the current calendar day in
 * the till's timezone. Without a timezone we can't tell, so we treat it as invalid.
 */
export function isSessionStartedToday(
  startedAt: number,
  timezone: string | undefined
): boolean {
  if (!timezone) return false;

  const start = moment.unix(startedAt).tz(timezone);
  return start.isSame(moment.tz(timezone), "day");
}
